import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import StatsSection from "./StatsSection"
import TransfersTab from "./TransfersTab"
import ReceiveLinksTab from "./ReceiveLinksTab"
import QuotasTab from "./QuotasTab"

// Wrap each tab body with consistent page padding. SidePanelLayout renders the
// active TabComponent with no props, so each section is self-contained.
const withPadding = (Comp) => () =>
  (
    <div className="p-6 max-w-7xl mx-auto">
      <Comp />
    </div>
  )

// Admin transfer browser. Side menu comes from the CMS MenuItem
// "TransferBrowserMenu" (Dashboard → /admin/transfers/dashboard, Transfers →
// /admin/transfers/transfers, Receive Links → /admin/transfers/receive-links,
// plus a Back item → /admin). Tab keys match the trailing URL segment.
const TransferBrowser = () => {
  return (
    <SidePanelLayout
      menuName="TransferBrowserMenu"
      tabs={{
        dashboard: withPadding(StatsSection),
        transfers: withPadding(TransfersTab),
        "receive-links": withPadding(ReceiveLinksTab),
        quotas: withPadding(QuotasTab),
      }}
    />
  )
}

export default TransferBrowser
